import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_user_event_RowClass} from '../../../dbschema/bl_wf_user_event.model';
import {bl_wf_user_ext_RowClass} from '../../../dbschema/bl_wf_user_ext.model';
import {bl_wf_user_hdr_RowClass} from '../../../dbschema/bl_wf_user_hdr.model';
import {bl_wf_user_line_RowClass} from '../../../dbschema/bl_wf_user_line.model';

export class WfUserContainerModel extends BaseContainerModel {
  wfUserHdr: bl_wf_user_hdr_RowClass = new bl_wf_user_hdr_RowClass();
  wfUserLineList: bl_wf_user_line_RowClass[] = [];
  wfUserExtList: bl_wf_user_ext_RowClass[] = [];
  wfUserEventList: bl_wf_user_event_RowClass[] = [];
}
